module.exports = __webpack_public_path__ + "fonts/IQOS-Regular.fbcaf25.woff2";